import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38')
];

export const server_loads = [0];

export const dictionary = {
		"/": [~3],
		"/about": [~5],
		"/admin": [~6],
		"/admin/error-logs": [~7],
		"/admin/forum": [~8],
		"/admin/ideas": [~9],
		"/admin/roadmap": [~10],
		"/admin/tasks": [~11],
		"/admin/users": [~12],
		"/agb": [~13],
		"/anmeldung-party": [~14],
		"/artist-werden": [~15],
		"/artists": [~16],
		"/aussteller": [~17],
		"/auth": [18],
		"/award": [~19],
		"/club-manager": [~20],
		"/contact": [~21],
		"/dashboard": [~22],
		"/datenschutz": [~23],
		"/events": [~24],
		"/events/[slug]": [~25],
		"/faq": [~26],
		"/feedback": [~27],
		"/impressum": [~28],
		"/knowledgebase": [~29],
		"/merch": [~30],
		"/nextlevel-djs": [~31],
		"/nextlevel-djs/[slug]": [~32],
		"/post/[slug]": [~33],
		"/presse": [~34],
		"/sentry-example": [35],
		"/sign-up": [36],
		"/up-to-date": [~37],
		"/videos": [~38],
		"/[slug]": [~4,[],[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';